import type { HttpClient } from '@wix/cli-http-client';
import type { BiLogger } from '@wix/cli-telemetry';
import { Uploader } from '@wix/app-cloud-uploader';
import { wixCliAppBiEvents } from '../bi/events.js';

export class HostingService {
  private readonly uploader: Uploader;

  constructor(
    private readonly appId: string,
    private readonly biLogger: BiLogger,
    httpClient: HttpClient
  ) {
    this.uploader = new Uploader(httpClient);
  }

  async uploadApplication(
    folderToUpload: string
  ): Promise<{ serveUrl: string }> {
    const biEvents = wixCliAppBiEvents(this.biLogger);

    const { fileCount, totalSizeKb } =
      await this.uploader.getUploadStats(folderToUpload);

    const uploadStatus = biEvents.fileUpload({
      provider: 'Wix',
      fileCount,
      totalSizeInKb: totalSizeKb,
    });

    const { serveUrl } = await this.uploader.upload({
      appId: this.appId,
      folderToUpload,
    });

    uploadStatus.finished();

    return {
      serveUrl,
    };
  }
}
